var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipChronometer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21009 5.25H6.33509V9.1875H7.21009V5.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08509 1.3125H5.46009V2.1875H8.08509V1.3125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0226 4.375L11.4013 3.75813L10.417 4.7425C9.61118 3.81195 8.47785 3.22763 7.25245 3.11093C6.02706 2.99424 4.80381 3.35415 3.83687 4.11589C2.86993 4.87762 2.23364 5.98261 2.06021 7.20127C1.88678 8.41994 2.18954 9.65857 2.90558 10.6598C3.62162 11.6611 4.6959 12.3479 5.9052 12.5777C7.1145 12.8075 8.36584 12.5626 9.39924 11.8938C10.4326 11.225 11.1686 10.1837 11.4543 8.98639C11.74 7.78906 11.5533 6.5277 10.9332 5.46438L12.0226 4.375ZM6.77259 11.8125C5.99382 11.8125 5.23255 11.5816 4.58503 11.1489C3.93751 10.7163 3.43283 10.1013 3.13481 9.38182C2.83679 8.66233 2.75882 7.87063 2.91075 7.10683C3.06267 6.34303 3.43768 5.64144 3.98835 5.09077C4.53902 4.5401 5.24062 4.16509 6.00442 4.01316C6.76822 3.86123 7.55992 3.9392 8.2794 4.23722C8.99889 4.53524 9.61384 5.03992 10.0465 5.68744C10.4792 6.33496 10.7101 7.09624 10.7101 7.875C10.7101 8.91929 10.2952 9.92081 9.55682 10.6592C8.81839 11.3977 7.81688 11.8125 6.77259 11.8125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipChronometer);
export default __webpack_public_path__ + "static/media/ic-chip-chronometer.16bdb4f7a40fe6aa7d563d5776266b0b.svg";
export { ForwardRef as ReactComponent };